var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-group"},_vm._l((_vm.context.options),function(option,index){return _c('button',{key:index,class:{
      btn: true,
      'btn-default': _vm.context.model !== option.value,
      'btn-primary': _vm.context.model === option.value
    },attrs:{"type":"button"},on:{"click":function($event){_vm.context.model = option.value}}},[_vm._v("\n    "+_vm._s(option.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b19c3ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Formulate/ButtonGroup.vue
// module id = 378
// module chunks = 0